import React from 'react';
import Queue from './Queue';
import DinamicScreen from '../../GeneralComponents/DinamicScreen';

const AttQueue = () => {
    return (
        <DinamicScreen>
            <Queue />
        </DinamicScreen>
    )
}

export default AttQueue